import {FlexBox, GridBox} from '@esgi/ui/layout';
import {Text} from '@esgi/ui/typography';

type Props = {
    value: number | null;
    maxValue: number;
    caption?: string;
};

export function AnswersInfo({value, maxValue, caption}: Props) {
	return (
        <GridBox>
            <FlexBox align={value ? 'end' : 'center'} data-cy='answers-info'>
                <Text size='medium' bold font='mono' color='neutral20'>
                    {value ?? '-'}
                </Text>
                <Text size='xSmall' font='mono' color='neutral64'>
                    {' '}
                    / {maxValue}
                </Text>
            </FlexBox>
            {caption && (
                <Text size='xSmall' font='mono' color='neutral48'>
                    {caption}
                </Text>
            )}
        </GridBox>
	);
}
